import { Injectable } from '@angular/core';
import { catchError, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DTO } from 'shared-lib';

@Injectable({
  providedIn: 'root',
})
export class ConversationService {
  constructor(private http: HttpClient) {}

  getContacts(): Promise<DTO.ContactDTO[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get<DTO.ContactDTO[]>(`chat/contacts`)
        .pipe(
          tap((contacts) => {
            resolve(contacts);
          }),
          catchError((error) => {
            console.error('error:', error);
            reject(false);
            return of(false);
          })
        )
        .subscribe();
    });
  }
  
  getContact(id: number): Promise<DTO.ContactDTO> {
    return new Promise((resolve, reject) => {
      this.http
        .get<DTO.ContactDTO>(`chat/contact/${id}`)
        .pipe(
          tap((contact) => {
            resolve(contact);
          }),
          catchError((error) => {
            console.error('error:', error);
            reject(false);
            return of(false);
          })
        )
        .subscribe();
    });
  }
}
